var _path, _ellipse, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 90,
    viewBox: "0 0 57 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39C0 27.9543 8.95431 19 20 19H37C48.0457 19 57 27.9543 57 39V50C57 61.0457 48.0457 70 37 70H20C8.9543 70 0 61.0457 0 50V39Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 26,
    rx: 21.5,
    ry: 26,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25C42.8458 22.0732 35.5415 22.0732 27.5333 22.0732C19.5252 22.0732 14.1542 22.0732 14 25C14 13.9543 20.4919 5 28.5 5C36.5081 5 43 13.9543 43 25Z",
    fill: "#B57F93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1579 22H53V25H14L14.1579 22Z",
    fill: "#B57F93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0086 41.6698C34.6799 41.6817 37.8203 41.178 37.4188 46.2708C38.1927 52.3845 33.193 51.3569 27.9914 51.3476C22.7898 51.3384 17.7855 52.8575 18.5821 46.2373C17.8082 40.1236 22.807 41.6606 28.0086 41.6698Z",
    fill: "#B57F93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.ec7e6af9f563d532709a1ed5e9bc4e5d.svg";
export { ForwardRef as ReactComponent };